import React from "react";
import type {
  Reference,
  ReferenceValidation,
} from "../../../../application/domain/proc-management";
import { ListInput } from "./list-input";
import ReferenceInput from "./reference-input";
import type { InputProps, PathProps } from "./types";

const notices = [
  "手続きを行うにあたって、参照できる情報が外部にある場合、そのリンクを列挙します。",
];

type Props = InputProps &
  PathProps & { value: Reference[]; validationErrors: ReferenceValidation[] };

export const ProcedureReferencesListInput: React.FC<Props> = ({
  value,
  onChange,
  disabled = false,
  basePath,
  shouldDisplayError,
  validationErrors,
}) => {
  return (
    <ListInput
      label="リンク集"
      component={ReferenceInput}
      componentProps={value.map((v, i) => ({
        ...v,
        onChange,
        shouldDisplayError,
        validationErrors: validationErrors[i],
      }))}
      basePath={basePath}
      onPush={() => {
        onChange(basePath, [...value, {}]);
      }}
      onRemove={(i) => {
        onChange(basePath, [...value.slice(0, i), ...value.slice(i + 1)]);
      }}
      disabled={disabled}
      notices={notices}
    />
  );
};
